exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@use 'sass:map';.no-scroll[data-v-128f7fa0]{position:relative;z-index:100;overflow:hidden}.page-title--seo[data-v-128f7fa0]{visibility:hidden;height:0;margin:0;padding:0}\n", ""]);
